import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from './components/Header/Header';
import Footer from './components/footer/Footer';
import LoadingContainer from './components/Loading/Loading';
import ScrollToTopButton from './components/Upbtn/Upbtn';
import { useLocation } from 'react-router-dom';


const Dashboard = lazy(() => import( './pages/Dashboard/Dashboard'));
const Shop = lazy(() => import('./pages/Shop/Shop'));
const HomePage = lazy(() => import('./pages/HomePage/HomePage'));
const SignIn = lazy(() => import('./pages/SignIn_Up/SignIn'));
const SignUp = lazy(() => import('./pages/SignIn_Up/SignUp'));
const MyAccount = lazy(() => import('./pages/MyAccount/MyAccount'));
const Items = lazy(() => import('./pages/Shoping/items'));
const ProductDetails=lazy(() => import('./pages/Shoping/ProductDetails'));
const Cart = lazy(() => import('./components/Cart/Cart'));
const AccountDetails = lazy(() => import('./pages/MyAccount/AccountDetails'));
const ContactUs = lazy(() => import('./pages/ContactUs/ContactUs'));
const OtpSuccess = lazy(() => import('./pages/OtpSuccess/OtpSuccess'));
const Home = lazy(() => import('./pages/SystemHomePage/Home'));
const Clients = lazy(() => import('./pages/Clients/Clients'));
const Mward = lazy(() => import('./pages/Mward/Mward'));
const Company = lazy(() => import('./pages/Company/Company'));
const Employee = lazy(() => import('./pages/Employee/Employee'));
const EmployeeCommission = lazy(() => import('./pages/Employee/EmployeeCommission'));
const AttendanceManagement = lazy(() => import('./pages/Employee/AttendanceManagement'));
const Wallet = lazy(() => import('./pages/Wallet/Wallet'));
const Store = lazy(() => import('./pages/Store/Store'));
const Product = lazy(() => import('./pages/Product/Product'));
const Kind = lazy(() => import('./pages/Product/Kind'));
const Color = lazy(() => import('./pages/Product/Color'));
const StockTransfer = lazy(() => import('./pages/StockTransfer/StockTransfer'));
const EditStock = lazy(() => import('./pages/StockTransfer/EditStock'));
const PreviousTransfers = lazy(() => import('./pages/StockTransfer/PreviousTransfers'));
const WalletTransfer = lazy(() => import('./pages/Wallet/Wallettransfer'));
const Expenses = lazy(() => import('./pages/Wallet/Expenses'));
const OldExpenses = lazy(() => import('./pages/Wallet/OldExpenses'));
const Invoice = lazy(() => import('./pages/Invoice/Invoice'));
const PurchaseInvoice = lazy(() => import('./pages/Invoice/PurchaseInvoice'));
const SelectClient = lazy(() => import('./pages/Invoice/SelectClient'));
const SelectMward = lazy(() => import('./pages/Invoice/SelectMward'));
const SelectInvoice = lazy(() => import('./pages/Invoice/SelectInvoice'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));
const PrevInvoice = lazy(() => import( './pages/Invoice/PrevInvoice'));
const Favourites = lazy(() => import('./components/favorites/Favourites'));
const WaitInvoice = lazy(() => import('./pages/Invoice/waitingInvoice'));
const Checkout = lazy(() => import('./pages/CheckOut/Checkout'));
const SendProducts = lazy(() => import('./pages/SendProducts/SendProducts'));
const Orders  = lazy(() => import( './pages/OrdersApprove/Orders'));
const RecieveProducts  = lazy(() => import( './pages/RecieveProducts/RecieveProducts'));
const Receipt  = lazy(() => import( './pages/RecieveProducts/Receipt'));
const ProductInquiry  = lazy(() => import( './pages/Product/ProductInquiry'));
const ShortageInventory  = lazy(() => import( './pages/Product/ShortageInventory'));
const AdminProductsPage  = lazy(() => import( './pages/OrdersApprove/AdminProductsPage'));
const CustomerStatement  = lazy(() => import( './pages/Users/CustomerStatement'));
const UsersManagement  = lazy(() => import( './pages/Admin/UsersManagement'));

export default function App() {
  const theme = useSelector((state) => state.theme.theme);
   const location = useLocation();
  const isSystemPage =location.pathname.includes('/OtpSuccess');
  return (
    <div className={`App ${theme}`}>
      <Header />
      <Suspense fallback={<LoadingContainer />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/MyAccount/MyAccount" element={<MyAccount />} />
          <Route path="/Shop/Shop" element={<Shop />} />
          <Route path="/SignIn_Up/SignIn" element={<SignIn />} />
          <Route path="/SignIn_Up/SignUp" element={<SignUp />} />
          <Route path="/fav" element={<Favourites />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/Shoping/items" element={<Items />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/Proceed-to-check-out" element={<Checkout />} />
          <Route path="/SendProducts" element={<SendProducts />} />
          <Route path="/RecieveProducts" element={<RecieveProducts />} />
          <Route path="/Receipt" element={<Receipt />} />
          <Route path="/Orders" element={<Orders />} />
          <Route path="/Ordersitems" element={<AdminProductsPage />} />
          <Route path="/MyAccount/AccountDetails" element={<AccountDetails />} />
          <Route path="/ContactUs/ContactUs" element={<ContactUs />} />
          <Route path="/OtpSuccess/OtpSuccess" element={<OtpSuccess />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/SystemHomePage/Home" element={<Home />} />
          <Route path="/Clients/Clients" element={<Clients />} />
          <Route path="/Mward/Mward" element={<Mward />} />
          <Route path="/Employee/Employee" element={<Employee />} />
          <Route path="/Employee/EmployeeCommission" element={<EmployeeCommission />} />
          <Route path="/Employee/AttendanceManagement" element={<AttendanceManagement />} />
          <Route path="/Company/Company" element={<Company />} />
          <Route path="/Wallet/Wallet" element={<Wallet />} />
          <Route path="/Store/Store" element={<Store />} />
          <Route path="/Product/Product" element={<Product />} />
          <Route path="/Product/Kind" element={<Kind />} />
          <Route path="/Product/Color" element={<Color />} />
          <Route path="/StockTransfer/StockTransfer" element={<StockTransfer />} />
          <Route path="/StockTransfer/EditStock" element={<EditStock />} />
          <Route path="/StockTransfer/PreviousTransfers" element={<PreviousTransfers />} />
          <Route path="/Wallet/Wallettransfer" element={<WalletTransfer />} />
          <Route path="/Wallet/Expenses" element={<Expenses />} />
          <Route path="/Wallet/OldExpenses" element={<OldExpenses />} />
          <Route path="/Invoice/SelectClient/:type" element={<SelectClient />} />
          <Route path="/Invoice/SelectMward/:type" element={<SelectMward/>} />
          <Route path="/Invoice/Invoice" element={<Invoice />} />
          <Route path="/Invoice/PurchaseInvoice" element={<PurchaseInvoice />} />
          <Route path="/Invoice/SelectInvoice/:type" element={<SelectInvoice />} />
          <Route path="/Invoice/PrevInvoice" element={<PrevInvoice />} />
          <Route path="/Waiting" element={< WaitInvoice />} />
          <Route path="/Product/ProductInquiry" element={< ProductInquiry />} />
          <Route path="/Product/ShortageInventory" element={< ShortageInventory />} />
          <Route path="/Users/CustomerStatement" element={< CustomerStatement />} />
          <Route path="/Admin/UsersManagement" element={< UsersManagement />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <ScrollToTopButton />
      {!isSystemPage && <Footer />}
    </div>
  );
}